/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbMobileRefineMenuFilterStoneCut_itemSearch = {
    readonly " $fragmentRefs": FragmentRefs<"SbSharedRefineMenuMultiSelectSearch_itemSearch">;
    readonly " $refType": "SbMobileRefineMenuFilterStoneCut_itemSearch";
};
export type SbMobileRefineMenuFilterStoneCut_itemSearch$data = SbMobileRefineMenuFilterStoneCut_itemSearch;
export type SbMobileRefineMenuFilterStoneCut_itemSearch$key = {
    readonly " $data"?: SbMobileRefineMenuFilterStoneCut_itemSearch$data;
    readonly " $fragmentRefs": FragmentRefs<"SbMobileRefineMenuFilterStoneCut_itemSearch">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbMobileRefineMenuFilterStoneCut_itemSearch",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuMultiSelectSearch_itemSearch"
    }
  ],
  "type": "ItemSearchQueryConnection",
  "abstractKey": null
};
(node as any).hash = 'ab3e8a046c2973f6a8062b2890096ab3';
export default node;
